import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';
import { validatePercentageValues } from './util';

/**
  Simple PercentageChart component
  Horizontal line with marker
  indicating a set of percentage values
  with corresponding labels.
*/
const PercentageChart = ({ data }) => {
  validatePercentageValues(data);

  const sum = data.reduce((accumulator, [, value]) => accumulator + value, 0);

  // scale each value as a percentage of their sum
  const scaleFactor = 100 / sum;
  const normalizedData = data.map(([label, value, color]) => [
    label,
    value * scaleFactor,
    color
  ]);

  return (
    <>
      <div className="bar">
        {normalizedData.map(([label, value, color]) => {
          const markerStyle = {
            width: `${value}%`,
            background: color.toString()
          };

          return (
            <div
              key={`marker-${label}`}
              style={markerStyle}
              className="marker"
            />
          );
        })}
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

PercentageChart.propTypes = {
  /**
      Array of data, values are three element array
      First value "label", second value "percent value" 
      third element "color"
    */
  data: PropTypes.arrayOf(PropTypes.array).isRequired
};

export default PercentageChart;
